/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import { LogLevels, sendLogToNewRelic } from './NewRelicLogService';

const isProduction = ENVIRONMENT === 'production';

export default class Logger {
    static info(message, options) {
        sendLogToNewRelic(message, LogLevels.INFO);

        Sentry.captureMessage(message);

        if (!isProduction) {
            console.log(message, options);
        }
    }

    static warn(message, options) {
        sendLogToNewRelic(message, LogLevels.WARN);

        Sentry.captureMessage(message);

        if (!isProduction) {
            console.warn(message, options);
        }
    }

    static error(message) {
        sendLogToNewRelic(message, LogLevels.ERROR);

        Sentry.captureException(new Error(message));

        if (!isProduction) {
            console.error(message);
        }
    }
}
